// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"597":"projects","893":"training"}[chunkId] + "." + {"597":"750829cd","893":"b6d8c9e9"}[chunkId] + ".js";
};